import {getProjectListAudit, getLabApplyCount, getLabListAudit, getLabListAuditCount, modifyLabAuditStatus, applyForLab, getLabApply, updateApplyForLab, updateLabAudit} from 'api/audit'

const audit = {
  state: {
    auditLabList: [],
    auditLabListTotal: 0,
    auditStatus: {}
  },
  mutations: {
    SET_AUDITLABLIST: (state, data) => {
      state.auditLabList = data
      // state.auditLabListTotal = data.totalCount[0]
    },
    SET_MODILABAUDITSTATUS: (state, list) => {
      state.auditStatus = list
    }
  },
  actions: {
    getLabListAuditData ({commit}, data) {
      return new Promise((resolve, reject) => {
        getLabListAudit(data).then((res) => {
          commit('SET_AUDITLABLIST', res.result)
          resolve(res.result)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getLabListAuditCount ({commit}, data) {
      return new Promise((resolve, reject) => {
        getLabListAuditCount(data).then((res) => {
          resolve(res.result)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    modifyLabAuditStatus ({commit}, data) {
      return new Promise((resolve, reject) => {
        modifyLabAuditStatus(data).then((res) => {
          console.log(res)
          commit('SET_MODILABAUDITSTATUS', res)
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getProjectMemlist ({commit}) {
      return new Promise((resolve, reject) => {
        getProjectListAudit().then((res) => {
          resolve(res.result)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    applyForLab ({commit}, params) {
      return new Promise((resolve, reject) => {
        applyForLab(params).then((res) => {
          resolve(res.result)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    getLabApplyCount ({commit}, params) {
      return new Promise((resolve, reject) => {
        getLabApplyCount(params).then((res) => {
          resolve(res.result)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    getLabApply ({commit}, params) {
      return new Promise((resolve, reject) => {
        getLabApply(params).then((res) => {
          resolve(res.result)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    updateApplyForLab ({commit}, params) {
      return new Promise((resolve, reject) => {
        updateApplyForLab(params).then((res) => {
          resolve(res.result)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    updateLabAudit ({commit}, params) {
      return new Promise((resolve, reject) => {
        updateLabAudit(params).then((res) => {
          resolve(res.result)
        }).catch((error) => {
          console.log(error)
        })
      })
    }
  }
}
export default audit



// WEBPACK FOOTER //
// ./src/store/modules/admin/audit.js